import { request } from './request';

/**
 * 根据ID获取新闻资讯详情
 * @param id - 新闻ID
 */
export function getArticleById(id: number) {
  return request.get(`/articles/${id}`);
}

/**
 * 按照新闻资讯类别检索-分页
 * @param params - 查询参数
 * @param params.categoryId - 类别ID
 * @param params.pageNum - 页码
 * @param params.pageSize - 每页数量
 */
export function getArticlesByCategory(params: any) {
  return request.post('/articles/columnPageSearch', params);
}

/**
 * 全类别检索-分页
 * @param params - 查询参数
 * @param params.pageNum - 页码
 * @param params.pageSize - 每页数量
 * @param params.searchKey - 搜索关键词
 */
export function searchArticles(params: any) {
  return request.post('/articles/pageSearch', params);
}

/**
 * 政策查询接口 - 分页搜索文章
 * @param params - 查询参数
 * @param params.pageNum - 页码
 * @param params.pageSize - 每页数量
 * @param params.searchKey - 搜索关键词
 */
export interface PolicySearchParams {
  pageNum: number;
  pageSize: number;
  searchKey: string;
}

export interface ArticleItem {
  attachment: string;
  author: string;
  categoryId: number;
  content: string;
  contentText: string;
  coverImage: string;
  id: number;
  publishTime: string;
  subtitle: string;
  summary: string;
  title: string;
}

export interface PolicySearchResponse {
  code: number;
  data: {
    endRow: number;
    firstPage: boolean;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    lastPage: boolean;
    list: ArticleItem[];
    navigateFirstPage: number;
    navigateLastPage: number;
    navigatePages: number;
    navigatepageNums: number[];
    nextPage: number;
    pageNum: number;
    pageSize: number;
    pages: number;
    prePage: number;
    size: number;
    startRow: number;
    total: number;
  };
  msg: string;
  total: number;
}

export function getPolicyList(params: PolicySearchParams) {
  return request.post('/articles/pageSearch', params);
}
